import { render } from "./pagination.vue?vue&type=template&id=068f3363&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=068f3363&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/CIS-school.vip.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068f3363"]])

export default __exports__